var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg24Hoverstqge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 82,
    viewBox: "0 0 88 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20167 79.6775C12.2694 76.3849 14.9471 72.2758 16.8083 68.1403C18.081 65.3139 19.0463 62.0577 18.0314 59.1221C16.9835 56.0907 14.1372 54.1998 11.7537 52.1105C6.32563 47.3403 3.03307 41.0791 2.42481 33.8031C1.82977 26.7023 3.80663 19.456 7.95208 13.7304C12.676 7.20807 19.8232 2.69567 27.7934 2.35518C34.9306 2.05105 42.2959 3.72047 48.0909 7.99815C53.886 12.2758 57.8926 19.3535 57.6579 26.6659C57.5851 28.9601 57.2876 31.4692 58.0777 33.6577C58.5736 35.0362 59.5885 36.3287 60.5372 37.413C61.1323 38.0907 61.6909 38.8213 62.3918 39.3767C63.0926 39.932 63.4727 40.2858 64.0215 40.9965C64.5703 41.7072 64.9207 42.6329 64.7653 43.5254C64.6298 44.2891 64.1339 44.9502 63.5389 45.4296C62.9438 45.9089 62.2397 46.2329 61.5488 46.5502C61.1686 46.5139 60.9372 46.8345 60.881 47.2213C60.8248 47.6081 60.9769 47.9948 61.1752 48.3287C61.3736 48.6626 61.6182 48.97 61.7736 49.3238C62.048 49.9453 62.0182 50.7023 61.7008 51.3006C61.3802 51.899 60.7422 52.3585 60.0843 52.4577C60.6694 52.4114 61.2546 52.8477 61.4298 53.4196C61.605 53.9948 61.4463 54.6362 61.1157 55.132C60.7851 55.6279 60.2959 55.9948 59.7868 56.2891C59.205 56.6229 59.0397 57.1353 59.1256 57.813C59.2083 58.4907 59.5058 59.1254 59.5918 59.7998C59.7868 61.3601 58.7686 62.8874 57.4331 63.661C56.0942 64.4345 54.5008 64.5866 52.9637 64.5535C48.0579 64.4543 43.205 62.6097 39.4165 59.4163",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6215 63.3569C43.3901 68.914 41.7075 73.8892 40.1372 79.6776",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7273 46.9502V58.851",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6777 49.9255V55.876",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6282 51.4131V54.3883",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7769 51.4131V54.3883",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg24Hoverstqge);
export default __webpack_public_path__ + "static/media/24_Hoverstqge.6272832fd46f498bbb0f34296637bd61.svg";
export { ForwardRef as ReactComponent };